import Cookies from 'js-cookie';

const hasStatisticsCookieConsent = () => {
  const cookieConsent = Cookies.get('CookieConsent');
  if (!cookieConsent) return false;

  const parsed = JSON.parse(
    cookieConsent
      .replace(/([{|,])\s*([a-zA-Z0-9]+):/g, '$1"$2":')
      .replace(/'/g, '"')
  );
  return !!parsed?.statistics;
};
export default hasStatisticsCookieConsent;
